import { bindActionCreators, Dispatch } from 'redux'
import get from 'lodash/get'
import { connect } from 'react-redux'
import { getFinanceDataAction } from 'store/actions/owner/ownerData'
import { formatPNLData } from 'components/AppDataReport/AppData/AppFinance/utils'
import { AppFinance } from 'components/AppDataReport/AppData/AppFinance/AppFinance.component'

const appFinanceDataProps = (state: any) => {
  return {
    isLoading: state.loadingStatus.financeDataLoading,
    financeData: {
      ...state.owner.financeData,
      pnlData: {
        ...get(state.owner.financeData, 'pnlData'),
        chartData: formatPNLData(get(state.owner.financeData, 'pnlData.chartData')),
      },
    },
  }
}

function appFinanceDataDispatch(dispatch: Dispatch) {
  return bindActionCreators(
    {
      getFinanceDataAction: getFinanceDataAction.STARTED,
    },
    dispatch
  )
}
export const AppFinanceContainer = connect(appFinanceDataProps, appFinanceDataDispatch)(AppFinance)
